import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-horizontal-chart',
  templateUrl: './horizontal-chart.component.html',
  styleUrls: ['./horizontal-chart.component.scss'],
})
export class HorizontalChartComponent implements OnInit {
  @Input() data: any;
  etapas = [{ name: '', value: 0 }];
  no_tratado: string;
  notificado: string;
  planificado: string;
  en_ejecucion: string;
  ejecutado: string;
  validado: string;
  colorScheme = {
    domain: [
      'whitesmoke',
      'white',
      'yellow',
      'orange',
      'greenyellow',
      'green',
      'blue ',
    ],
  };
  colorSchema = {
    domain: ['#00e800', ' #ff0000 '],
  };
  constructor(private translate: TranslateService) {}
  axisFormat(val) {
    if (val % 1 === 0) {
      return val.toLocaleString();
    } else {
      return '';
    }
  }
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    this.etapas = [{ name: '', value: 0 }];
    if (this.data.length != 0) {

      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_not_treated',
          { value: this.data.no_tratado }
        ),
        value: this.data.no_tratado,
      });
      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_notified',
          { value: this.data.notificados }
        ),
        value: this.data.notificados,
      });
      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_planned',
          { value: this.data.planificado }
        ),
        value: this.data.planificado,
      });
      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_in_action',
          { value: this.data.en_ejecucion }
        ),
        value: this.data.en_ejecucion,
      });
      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_executed',
          { value: this.data.ejecutada }
        ),
        value: this.data.ejecutada,
      });
      this.etapas.push({
        name: this.translate.instant(
          'action_plan.statistics.graphics.stages_validated',
          { value: this.data.fecha_validacion }
        ),
        value: this.data.fecha_validacion,
      });
    }
  }
}
